import { render, staticRenderFns } from "./ImpressumComp.vue?vue&type=template&id=7ba45cae"
import script from "./ImpressumComp.vue?vue&type=script&lang=js"
export * from "./ImpressumComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports